import { color } from '@upstox/upstox-ui';

export const surveillanceMsgContainer: CSSFunction = () => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  width: '100%',
});

export const container: CSSFunction = () => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  maxHeight: '108px',
});

export const warningBox: CSSFunction = ({ theme }) => ({
  padding: '8px 8px 0px 12px',
  border: `1px solid ${color(theme, 'ui1')}`,
  borderRadius: '2px',
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '150%',
  flexDirection: 'column',
  maxHeight: '250px',
  overflowY: 'scroll',
  width: '100%',
  '::-webkit-scrollbar': {
    '-webkit-appearance': 'none',
    width: 4,
  },
  '::-webkit-scrollbar-thumb': {
    borderRadius: '4px',
    backgroundColor: color(theme, 'ui8'),
    boxShadow: '0 0 1px rgba(255,255,255,0.5)',
  },
  '::-webkit-scrollbar-corner': {
    backgroundColor: 'inherit',
  },
});

export const bullets = {
  listStyleType: 'decimal',
  paddingLeft: '12px',
  margin: '0px',
};

export const instrumentWarning = {
  marginBottom: '8px',
  fontSize: '12px',
};

export const symbolName = {
  fontWeight: 600,
  marginRight: '5px',
};

export const learnMoreContainer: CSSFunction = () => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '8px',
  fontSize: '12px',
  textDecoration: 'none',
});

export const learnMore: CSSFunction = ({ theme }) => ({
  fontSize: '12px',
  cursor: 'pointer',
  color: color(theme, theme.colors.text.link),
});
